if (!customElements.get('country-province-selector')) {
  class CountryProvinceSelector extends HTMLElement {
    constructor() {
      super();
      this.countryEl = this.querySelector('.js-country-select');
      this.provinceEl = this.querySelector('.js-province-select');
      this.provinceContainer = this.querySelector('.js-province-container');
      this.init();
    }

    init() {
      CountryProvinceSelector.setSelectedOption(this.countryEl, this.countryEl.dataset.default);

      this.handleCountryChange();

      if (this.provinceEl.dataset.default && this.provinceEl.options.length > 0) {
        CountryProvinceSelector.setSelectedOption(this.provinceEl, this.provinceEl.dataset.default);
      }

      this.countryEl.addEventListener('change', this.handleCountryChange.bind(this));
    }

    handleCountryChange() {
      const selectedOption = this.countryEl?.options?.[this.countryEl.selectedIndex];
      if (!selectedOption || !this.provinceEl) return;

      let provinces = [];
      try {
        provinces = JSON.parse(selectedOption.dataset.provinces || '[]');
      } catch (error) {
        provinces = [];
      }

      Array.from(this.provinceEl.options).forEach((option) => option.remove());

      if (!provinces || provinces.length === 0) {
        if (this.provinceContainer) this.provinceContainer.hidden = true;
      } else {
        provinces.forEach((province) => {
          const option = document.createElement('option');
          [option.value, option.innerHTML] = province;
          this.provinceEl.appendChild(option);
        });

        if (this.provinceContainer) this.provinceContainer.hidden = false;
      }
    }

    static setSelectedOption(selector, value) {
      if (!selector || !value) return;
      Array.from(selector.options).forEach((option, index) => {
        if (option.value === value || option.innerHTML === value) {
          selector.selectedIndex = index;
        }
      });
    }
  }

  customElements.define('country-province-selector', CountryProvinceSelector);
}
